module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-468.3db48e0.woff2";